import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-change-value-action-renderer',
  template: `
    <button class="btn btn-link" style="padding: 0; margin-right: 15px;" (click)="changeValue()">
      {{ params.value ? 'Yes' : 'No' }}
    </button>
  `,
  standalone: false
})
export class ChangeValueActionRendererComponent implements AgRendererComponent {
  public params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  public changeValue(): void {
    this.params.context.changeValueHandler(this.params.colDef.field, this.params.data)
  }
}
